import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImport2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconImport2"><Path d="M17 4C13.8244 4 11.25 6.57436 11.25 9.75V13.1893L8.24999 10.1893L7.18933 11.25L12 16.0607L16.8107 11.25L15.75 10.1893L12.75 13.1893V9.75C12.75 7.40279 14.6528 5.5 17 5.5H22V4H17Z" fill="currentColor"/><Path d="M2 4V20H22V8H20.5V18.5H3.5V5.5H9V4H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImport2;
